__turbopack_context__.v({
  "button": "Fields-module-scss-module__07WMFa__button",
  "campaignForm": "Fields-module-scss-module__07WMFa__campaignForm",
  "error": "Fields-module-scss-module__07WMFa__error",
  "fade-in": "Fields-module-scss-module__07WMFa__fade-in",
  "field": "Fields-module-scss-module__07WMFa__field",
  "fieldWrapper": "Fields-module-scss-module__07WMFa__fieldWrapper",
  "full-width": "Fields-module-scss-module__07WMFa__full-width",
  "grid": "Fields-module-scss-module__07WMFa__grid",
  "half-width": "Fields-module-scss-module__07WMFa__half-width",
  "hasError": "Fields-module-scss-module__07WMFa__hasError",
  "input": "Fields-module-scss-module__07WMFa__input",
  "isDefault": "Fields-module-scss-module__07WMFa__isDefault",
  "root": "Fields-module-scss-module__07WMFa__root",
  "select": "Fields-module-scss-module__07WMFa__select",
});
